import React from 'react'
import PropTypes from 'prop-types'
class Loader extends React.Component {
  render () {
    return (
      <div className='text-center mt-16'>
        <div className={`vsd-lds-ring ${this.props.className}`} style={{ top: '20%' }}>
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    )
  }
}

Loader.propTypes = {
  className: PropTypes.string
}

export default Loader
